var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"insert_modal",on:{"close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }